import * as Sentry from '@sentry/react'

/**
 * We use this function if we want to send an error to sentry
 * without breaking the whole application.
 */
const sentryCatch = <T extends any[], R>(
  callback: (...args: T) => R
): ((...args: T) => R | undefined) => {
  const newCallback = (...args: T): R | undefined => {
    try {
      return callback(...args)
    } catch (error) {
      Sentry.captureException(error)
    }

    return undefined
  }

  return newCallback
}

export default sentryCatch
